/**
 * 官网新闻资讯（匿名接口，与 beauty-ui 维护的后台同源）
 * @returns {Promise<Array>}
 */
export function fetchPublicNews() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/news/public/list', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return Array.isArray(body.data) ? body.data : []
    })
}

/**
 * 官网新闻详情（匿名接口）
 * @param {string|number} id
 * @returns {Promise<Object|null>}
 */
export function fetchPublicNewsDetail(id) {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/news/public/detail/' + encodeURIComponent(id), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return body.data || null
    })
}
